import React, { useContext, useEffect, useState } from "react";
import { colorConstant } from "../../../../../../styles/colorConstant/colorConstant";
import { Box, Modal } from "@mui/material";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { XCircleIcon } from "@heroicons/react/20/solid";
import "./RecallOrderModal.css";
import vegIcon from "../../../../../../assets/images/veg-new.png";
import nonVegIcon from "../../../../../../assets/images/non-veg-new.png";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { PosCustomRadioButton } from "../../../../../../customComponents/PosCustomRadioButton/PosCustomRadioButton";
import PosCustomCheckBox from "../../../../../../customComponents/PosCustomCheckBox/PosCustomCheckBox";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { recallOrder } from "../../../../../../config/Services";
import { UserContext } from "../../../../../../App";
import useGetDevice from "../../../hooks/useGetDevice";

const RecallOrderModal = ({
  recallOrderModalOpen,
  setRecallOrderModalOpen,
  productTitle,
  cartQuantity,
  cartProductId,
  foodType,
  setShowFineDineActionButtons,
  setHasRequestedForNewItem,
}) => {
  const [returnQuantity, setReturnQuantity] = useState(cartQuantity);
  const [disableDecBtn, setDisableDecBtn] = useState(false);
  const [disableIncBtn, setDisableIncBtn] = useState(true);
  const [recallMode, setRecallMode] = useState("");
  const [checkedValue, setCheckedValue] = useState([]);
  const [reason, setReason] = useState("");
  const [updateLoader, setUpdateLoader] = useState(false);
  const {
    cartItems,
    setCartItems,
    setCgst,
    setSgst,
    setCess,
    setSubTotal,
    setTotal,
    setTotalValue,
    setTotalTaxes,
    setOfferFound,
    setCouponApplied,
  } = useContext(UserContext);

  const isMobileView = useGetDevice();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: isMobileView ? "92%" : 432,
    width: "auto",
    bgcolor: `${colorConstant.surfaceWhite}`,
    padding: "16px 16px 8px 16px",
    borderRadius: "12px",
    overflow: "scroll",
  };

  const showSnackbar = useSnackbar();
  const CartId = localStorage.getItem("CartId");
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));

  //Updating buttons status
  const updateButtonStates = (qty) => {
    setDisableDecBtn(qty <= 1 || qty === "");
    setDisableIncBtn(qty >= cartQuantity || qty === "");
  };

  //Validating buttons quantity
  const validateQuantity = (qty) => {
    if (qty === "") {
      return "";
    }
    if (qty < 1) {
      showSnackbar("Recall Quantity can't be less than 1", "error");
      return 1;
    }
    if (qty > cartQuantity) {
      showSnackbar("Recall Quantity exceeding original quantity", "error");
      return cartQuantity;
    }
    return qty;
  };

  //Handling form input change
  const handleInputChange = (e) => {
    let value = e.target.value;

    if (value === "") {
      setReturnQuantity("");
      updateButtonStates("");
      return;
    }

    let numValue = Number(value);
    if (isNaN(numValue)) {
      return;
    }

    numValue = validateQuantity(numValue);
    setReturnQuantity(numValue);
    updateButtonStates(numValue);
  };

  //Handling decrease button
  const handleDecreaseQty = () => {
    if (returnQuantity === "" || returnQuantity <= 1) return;
    const newQty = validateQuantity(returnQuantity - 1);
    setReturnQuantity(newQty);
    updateButtonStates(newQty);
  };

  //Handling increase button
  const handleIncreaseQty = () => {
    if (returnQuantity === "" || returnQuantity >= cartQuantity) return;
    const newQty = validateQuantity(returnQuantity + 1);
    setReturnQuantity(newQty);
    updateButtonStates(newQty);
  };

  //Handling submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const validatedQty = validateQuantity(returnQuantity);
    setReturnQuantity(validatedQty);
    updateButtonStates(validatedQty);
  };

  //Handling radio buttons
  const handleOptionChange = (e) => {
    const selectedOption = e.target.value;
    setRecallMode(selectedOption);
  };

  //Handling bill adjustment check box
  const handleCheckValue = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setCheckedValue([...checkedValue, value]);
    } else {
      setCheckedValue(checkedValue?.filter((item) => item !== value));
    }
  };

  //Handling modal close
  const handleClose = () => {
    setRecallOrderModalOpen(false);
  };

  //Handling update button
  const handleUpdate = () => {
    setUpdateLoader(true);
    const payload = {
      cartId: CartId,
      cartProductId: cartProductId,
      quantity: Number(returnQuantity),
      reason: recallMode,
      reasonDescription: reason,
      chargeApplicable: checkedValue?.length === 0 ? true : false,
      updatedBy: retailUserLocalStorageData?.uidx,
      comments: "",
    };
    recallOrder(payload)
      .then((res) => {
        if (
          res?.data?.data?.es > 0 ||
          res?.data?.data?.data?.es > 0 ||
          res?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.data?.message || "Unable to Recall the order", "error");
          setUpdateLoader(false);
          return;
        }
        setCartItems(res?.data?.data?.data?.cartProducts);
        setCgst(res?.data?.data?.data?.billing?.cgst);
        setSgst(res?.data?.data?.data?.billing?.sgst);
        setCess(res?.data?.data?.data?.billing?.totalCessAmount);
        setSubTotal(res?.data?.data?.data?.billing?.subtotal);
        setTotal(res?.data?.data?.data?.billing?.totalCartValue);
        setTotalValue(res?.data?.data?.data?.billing?.totalValue);
        setTotalTaxes(res?.data?.data?.data?.billing?.tax);
        setOfferFound(res?.data?.data?.data?.offerProductFound);
        setCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon);
        showSnackbar("Recall Successfull", "success");
        setShowFineDineActionButtons(false);
        setHasRequestedForNewItem(false);
        setUpdateLoader(false);
        handleClose();
      })
      .catch((err) => {
        showSnackbar(err?.message || "Unable to Recall the order", "error");
        setUpdateLoader(false);
      });
  };

  //Update buttons on changing cartQuantity
  useEffect(() => {
    updateButtonStates(returnQuantity);
  }, [cartQuantity]);

  return (
    <div>
      <Modal open={recallOrderModalOpen} onClose={handleClose}>
        <Box sx={style}>
          <div className="recallModalHeader">
            <p>Recall Order</p>
            <PosCustomIcon
              icon={<XCircleIcon />}
              color="var(--surface-black)"
              height={"22px"}
              width={"22px"}
              onClickFunction={handleClose}
              pointer={true}
            />
          </div>

          <div className="recallModalProductContainer">
            <div className="recallModalFoodType">
              <PosCustomIcon
                image={foodType === "VEG" ? vegIcon : nonVegIcon}
                height={"16px"}
                width={"16px"}
              />
              <p>{productTitle}</p>
            </div>

            <div className="recallModalQuantityContainer">
              <button className="recallModalButton" onClick={handleDecreaseQty}>
                <PosCustomIcon
                  icon={<MinusIcon />}
                  height={"16px"}
                  width={"16px"}
                  color={disableDecBtn ? "var(--blue-b2)" : "var(--blue-b0)"}
                />
              </button>
              <form onSubmit={handleSubmit}>
                <input
                  className="recallFormInput"
                  type="number"
                  value={returnQuantity}
                  onChange={handleInputChange}
                  style={{
                    width: `${Math.max(2, String(returnQuantity)?.length) + 1}ch`,
                  }}
                />
              </form>
              <button className="recallModalButton" onClick={handleIncreaseQty}>
                <PosCustomIcon
                  icon={<PlusIcon />}
                  height={"16px"}
                  width={"16px"}
                  color={disableIncBtn ? "var(--blue-b2)" : "var(--blue-b0)"}
                />
              </button>
            </div>
          </div>

          <div className="recallModalOptionsContainer">
            <PosCustomRadioButton
              id="RECALL"
              name="recallOption"
              value="RETURNED"
              label="Recall"
              variant="white-h"
              changeVariantOnSelect={"white-h"}
              fontSize={"1rem"}
              defaultIcon={false}
              iconOnLeft={true}
              radius={"4px"}
              fontWeight={400}
              transparent={true}
              iconColor={"var(--surface-g3)"}
              selectedValue={recallMode}
              onSelect={handleOptionChange}
            />
            <PosCustomRadioButton
              id="RECALL_AND_WASTAGE"
              name="recallOption"
              value="WASTAGE"
              label="Recall & mark as wastage"
              variant="white-h"
              changeVariantOnSelect={"white-h"}
              fontSize={"1rem"}
              defaultIcon={false}
              iconOnLeft={true}
              radius={"4px"}
              fontWeight={400}
              transparent={true}
              iconColor={"var(--surface-g3)"}
              selectedValue={recallMode}
              onSelect={handleOptionChange}
            />
          </div>

          <div className="billConsentContainer">
            <PosCustomCheckBox
              id={"BILL_CONSENT"}
              name={"consent"}
              value={"NO"}
              label={"Don't charge in the bill"}
              checkedValue={checkedValue}
              onCheck={handleCheckValue}
              defaultIcon={false}
              iconOnLeft
              checkBoxColor={"var(--surface-g3)"}
              checkMarkColor={"var(--surface-white)"}
              fontSize={"1rem"}
              fontWeight={400}
            />
          </div>

          <div className="textAreaSection">
            <p className="recallReasonHeader">Reason For Recall</p>
            <textarea
              className="recallInputBox"
              placeholder="Write the reason for recall"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

          <div className="recallActionButton">
            <PosCustomButton
              title="Update"
              variant="blue-d"
              p={"12px 16px"}
              radius={"6px"}
              width="100%"
              // iconOnRight={
              //   <PosCustomIcon
              //     icon={<ArrowPathIcon />}
              //     height={"20px"}
              //     width={"20px"}
              //     color="var(--surface-white)"
              //   />
              // }
              disabled={recallMode === ""}
              onClickFunction={handleUpdate}
              loading={updateLoader}
            />
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default RecallOrderModal;
